'use client';

import React from 'react';
import { BlogArticleCard } from '@/sanity/pages/PageBlogOverviewTemplate';
import { useArticleGrid } from './useArticleGrid';
import ArticleCard from './ArticleCard';

export default function ArticleList({
  articles,
}: {
  articles: BlogArticleCard[];
}) {
  const { visible } = useArticleGrid(articles);

  if (visible.length === 0) {
    return (
      <section className="w-full flex items-center justify-center py-[10rem]">
        <p className="mb-0 font-geist text-[2rem] text-white/50 tracking-[-0.06rem]">
          No articles yet.
        </p>
      </section>
    );
  }

  return (
    <section className="w-full flex flex-col ">
      {visible.map((article) => (
        <ArticleCard key={article._id} article={article} />
      ))}
    </section>
  );
}
